import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  ViewContainerRef,
  Input,
  HostListener,
} from '@angular/core';
@Component({
    selector: 'app-scaffold-sidebar-frame',
    templateUrl: './scaffold-sidebar-frame.component.html',
    styleUrl: './scaffold-sidebar-frame.component.scss',
    standalone: false
})
export class ScaffoldSidebarFrameComponent {
  @Input() settings: any;
  @Output() closed = new EventEmitter<void>();
  @ViewChild('content', { read: ViewContainerRef, static: true })
  viewContainerRef!: ViewContainerRef;

  close() {
    if (this.settings.closeOnBackdropClick) {
      this.closed.emit();
    }
  }

  isolate(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydown(event: KeyboardEvent) {
    if (this.settings.closeOnEsc) {
      this.closed.emit();
    }
  }
}
